import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

export const BackofficeGuard: CanMatchFn = async () => {
  const router = inject(Router);

  if (environment.production) {
    router.parseUrl('/dashboard/open');
    return false;
  }
  return true;
};
